import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { deepPurpleMui, greenMui, greyMui } from "@ryde/theme";

export const PriceRateAdditionPricingStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "price-rate-addition-pricing",
  },
)`
  .price-rate-addition-pricing-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 1px;
    margin-bottom: 15px;

    .price-level-item {
      display: grid;
      grid-template-columns: 1fr 55px;
      grid-template-rows: auto;
      border-radius: 5px;
      padding-bottom: 10px;
      padding-top: 6px;
      padding-inline-start: 5px;
      &.display-mode {
        border: 1px solid ${greyMui._400};
        margin-bottom: 12px;
      }
      &__data {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 5px 10px;
        gap: 10px;
        &--row {
          display: grid;
          grid-template-columns: 110px 1fr;
          label {
            color: ${greyMui._600};
            line-height: 1.8;
          }
          .price-level-cell {
            line-height: 1.8;
          }
        }
      }
      &__editors {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 14px;
      }
      &__buttons {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .edit-button {
          color: ${greenMui._600};
        }
      }
    }

    button.add_button {
      align-self: flex-start;
      margin-inline-start: 5px;
      color: ${greyMui._600};
      &:hover {
        color: ${deepPurpleMui._600};
      }
    }
  }
`;
